// extracted by mini-css-extract-plugin
export default {"position":"AddOnsGrid_position__4JQlq"};